@if (workplaceId) {
  <p-card>
    <app-table
      #icpsTable
      [gridData]="$any(store.data.workplaceIcps$ | async)"
      [columns]="columns"
      translatePrefix="workplace.icps."
      [tableTitle]="'workplace.icps.title'"
      [hideCheckboxes]="true"
      (createCallback)="openCreateIcp()"
      (detailCallback)="openEditIcp($event)"
      (deleteCallbackWithEvent)="delete($event)"
      [refreshCallback]="store.api.getWorkplaceIcps"
      [additionalFilter]="icpsAdditionalFilter"
      [defaultSorters]="[{ column: 'validFrom', direction: 'DESC' }]"
    ></app-table>
  </p-card>
}

<p-dialog
  header="{{ ('workplace.icps.form.' + (form.controls.id.value ? 'edit' : 'create') + 'Header') | translate }}"
  [(visible)]="modalVisible"
  [modal]="true"
  [maximizable]="false"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeModal()"
  >
  <div class="grid-1col input-grid-gaps">
    <app-date-input [form]="form" id="validFrom"></app-date-input>
    <app-insurance-company-select-input
      id="insuranceCompanyId"
      [form]="form"
      label="workplace.icps.form.insuranceCompanyId"
      valueKey="id">
    </app-insurance-company-select-input>
    <app-text-input
      id="icp"
      [form]="form"
      label="workplace.icps.form.icp"
    ></app-text-input>
  </div>

  <ng-template pTemplate="footer">
    <app-action-buttons (primaryClickEvent)="submit()" (secondaryClickEvent)="closeModal()"></app-action-buttons>
  </ng-template>
</p-dialog>
